import { type HttpOptions, createHttpLink } from '@apollo/client'
import got, { type Method, type Options } from 'got'

import { getAnvilUrl } from '@/lib/apollo/utils/getAnvilUrl'
import { parseInitHeaders } from '@/lib/apollo/utils/parseInitHeaders'

const serverHttpLink = () => {
  const url = getAnvilUrl()
  const enhancedFetch: HttpOptions['fetch'] = async (url, init) => {
    /**
     * The `url` parameter can be a `Request`, `URL`, or a string.
     * The associated ternary properly extracts the url if needed and converts it to a string
     */
    const _url = url instanceof Request ? url.url : url.toString()

    const { headers: initHeaders, body: initBody, method, ...restInit } = init ?? {}
    const _headers = initHeaders ? parseInitHeaders(initHeaders) : {}

    const options: Options = {
      ...restInit,
      body: initBody?.toString() ?? '',
      method: (method as Method) ?? 'GET',
      headers: {
        ..._headers,
        Cookie: '',
        origin: process.env.NEXT_PUBLIC_WEBAPP_URL ?? '',
      },
    }

    const response = await got(_url, options)

    // @ts-expect-error This is gon be there for now
    const { body, ...rest } = response
    const httpResponse = new Response(body ?? '', rest)

    return httpResponse
  }

  return createHttpLink({
    uri: url,
    fetch: enhancedFetch,
  })
}

export default serverHttpLink
